import { RenderCellProps } from '@/components/cashflow/transactions/TableRow';
import TagCircles from '@/components/cashflow/transactions/TagCircles';
import TagSelect from '@/components/cashflow/transactions/TagSelect';
import { FlexRow } from '@/components/common/Flex';

const TagsCell = ({ transactionEntry, onEdit }: RenderCellProps) => (
    <FlexRow align="center" justify="flex-end" mr={5} mt={1}>
        <TagCircles tags={transactionEntry.tags} />
        {transactionEntry.isPending ? (
            // Empty space to keep the layout consistent
            <FlexRow />
        ) : (
            <TagSelect
                transactionEntry={transactionEntry}
                onOpen={() => onEdit(true)}
                onClose={() => onEdit(false)}
            />
        )}
    </FlexRow>
);

export default TagsCell;
